import { FlexColumn, Input } from '@make-software/cspr-design';
import React from 'react';
import { TrafficTargetParams } from 'app/console-api/automations/types';
import { AutomationTypeControlProps } from 'app/components/common/automation/utils';
import { ErrorText, ErrorTextContainer } from 'app/components/common/common-styles';

export const TrafficTargetControl = ({ value, onChange, errors }: AutomationTypeControlProps) => {
  return (
    <FlexColumn gap={6}>
      <Input
        type="number"
        min={1}
        placeholder="Target value"
        value={(value as TrafficTargetParams).target}
        onChange={(e) => {
          const num = Number(e.target.value);
          onChange({
            ...value,
            target: Number.isFinite(num) ? num : 0
          });
        }}
      />
      {errors?.target && (
        <ErrorTextContainer justify={'flex-start'} top={'46px'}>
          <ErrorText size={3}>{errors?.target?.message}</ErrorText>
        </ErrorTextContainer>
      )}
    </FlexColumn>
  );
};
